import { Dispatch, FC, SetStateAction } from 'react';
import styles from './ToggleTab.module.scss';

export type ToggleTabItemType = {
  label: string;
  value: string;
};

/**
 * @param activeTab - Indicates active tab index
 * @param setActiveTab - Handle for change active tab
 * @param tabList - List of available tabs
 */
interface ToggleTabProps {
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<any>>;
  tabList: ToggleTabItemType[];
}

/**
 * @param props - The props for the component.
 * @returns A React component that displays a toggle tab.
 */
const ToggleTab: FC<ToggleTabProps> = (props) => {
  const { activeTab, setActiveTab, tabList } = props;

  const items = tabList.map((item) => {
    return (
      <div
        key={item.value}
        className={`${styles.toggleItem} ${activeTab === item.value && styles.active}`}
        onClick={() => setActiveTab(item.value)}
      >
        {item.label}
      </div>
    );
  });

  return <div className={styles.toggleContainer}>{items}</div>;
};

export { ToggleTab };
